module.exports = __webpack_public_path__ + "static/media/trofeus (6).91080041.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (6).jpg
// module id = 370
// module chunks = 0